import { RoutePermittedRole } from '@projectK/constants/AppEnums';
import React from 'react';
const CreditWallet = React.lazy(() =>
  import('../../modules/admin/CreditSystem/CreditWallets'),
);

export const creditManagerConfigs = [
  {
    permittedRole: RoutePermittedRole.User,
    path: '/my-profile',
    element: <CreditWallet />,
  },
];
